import { Component, Input, OnInit } from '@angular/core';
import { ModalController} from '@ionic/angular';

@Component({
  selector: 'app-pop-calendly',
  templateUrl: './pop-calendly.component.html',
  styleUrls: ['./pop-calendly.component.scss'],
})
export class PopCalendlyComponent implements OnInit {

  @Input() hasPostponeSettlementDate:boolean=false
  @Input() days:any
  constructor(
    private modalController: ModalController
  ) {

  }
  ngOnInit() { }

  async accept() {
    await this.modalController.dismiss('accept');
  }


}
